module.exports = __webpack_public_path__ + "static/media/team-5.e92b1bce.png";